import {useContext, useState} from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import './growth.css';


function Growth() {

    const {data, loading, error, isBY, isRU, isLocal, setModal} = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);

    let urlPrefix = "/images/";
    if (isLocal) urlPrefix = "https://sushi-tunec.com" + urlPrefix;

        const section = data.sectionsdata.find(s => s.nick === 'growth');
        const paragraphs = section ? section.paragraphsdata : [];

        return (
            <motion.section
                id="growth"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 1, delay: 0.5 }}
                onAnimationComplete={() => {
                    setShowItems(true);
                }}
            >
                <div className="inner_block">

                    <h2>{section.title}</h2>

                    {

                    paragraphs.map((par) => (

                    <>
                        <p>{par.text}</p>
                        { par.galerydata.length > 0 && (
                            <div className="galery">
                                {
                                    par.galerydata.map((gal, index) => (
                                        <motion.div
                                            key={index}
                                            initial={{ opacity: 0, y: 10, scale: 0.5 }}
                                            animate={ showItems ? { opacity: 1, y: 0, scale: 1 } : {}}
                                            transition={{ delay: index * 0.3, duration: 0.3 }}
                                            className="galery_item"
                                        >
                                            <img src={urlPrefix + gal.image} />

                                            {
                                                gal.text.map((line, index2) => (
                                                    <span key={index2}>{line}</span>
                                                ))
                                            }

                                        </motion.div>

                                    ))
                                }
                            </div>
                        )}

                    </>

                    ))

                    }

                    <div className="growth__footer">

                        Заключи договор в течении 7 дней

                        <p><span>Пицца в подарок</span><br />Один ресторан - два направления дохода</p>

                    </div>

                    <button onClick={() => setModal(true)}>Подробнее</button>

                </div>
            </motion.section>
        )



    }

export default Growth;